import React, { useEffect, useState } from "react";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import editBond from "../../assets/editBond.png";
import delBond from "../../assets/deleteBond.png";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
// import { toast } from "react-hot-toast";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const BondManagementMainPage = () => {
  const navigate = useNavigate();
  const [bondDetails, setBondDetails] = useState([]);
  const [requestBonds, setRequestBond] = useState([]);
  const [error, setError] = useState(null);
  const { userPermissionData } = useSelector((state) => state.userPermission);
  const [activeTab, setActiveTab] = useState("Bond List");

  const [selectNumber, setSelectedNumber] = useState("10");
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem("bondManagementPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [totalNewRequest, setTotalNewRequest] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const [getData, setGetData] = useState(false);

  const columnHelper = createColumnHelper();

  const optionsShow = ["All", "10", "20", "50"];

  const fetchBondDetails = async () => {
    const endpoint = `${base_url}/${api_type}/bonds`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          search: searchInputApi,
          page: page,
          limit:
            selectNumber === "All"
              ? total || undefined
              : parseInt(selectNumber),
        },
      });

      if (response.data.success) {
        setBondDetails(response?.data?.data?.bonds);
        setTotal(response?.data?.data?.totalRecords);
        setPazeSize(
          selectNumber === "All"
            ? response?.data?.data?.totalRecords
            : response?.data?.data?.pagination?.perPage ||
                parseInt(selectNumber)
        );
      }
    } catch (err) {
      console.error("Failed to fetch bonds:", err);
      toast.error(err.message || "Failed to fetch bonds");
    }
  };
  const fetchRequestDetails = async () => {
    const endpoint = `${base_url}/${api_type}/bondDirectoryRequest`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          search: searchInputApi,
          page: page,
          limit:
            selectNumber === "All"
              ? total || undefined
              : parseInt(selectNumber),
        },
      });

      console.log("response", response);

      if (response.data.success) {
        setRequestBond(response?.data?.data?.list);
        setTotalNewRequest(response?.data?.data?.totalRecords);
        // setPazeSize(
        //   selectNumber === "All"
        //     ? response?.data?.data?.totalRecords
        //     : response?.data?.data?.pagination?.perPage ||
        //         parseInt(selectNumber)
        // );
      }
    } catch (err) {
      console.error("Failed to fetch bonds:", err);
      toast.error(err.message || "Failed to fetch bonds");
    }
  };

  const deleteBondsId = async (id) => {
    const endpoint = `${base_url}/${api_type}/bonds/${id}`;

    try {
      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (response.data.success) {
        toast.success("Bond deleted successfully");
        fetchBondDetails();
      }
    } catch (err) {
      console.error("Failed to delete bond:", err);
      toast.error(err.message || "Failed to delete bond");
    }
  };
  const handleRequest = async (id, action) => {
    const endpoint = `${base_url}/${api_type}/bondDirectoryRequest/${id}`;

    try {
      const response = await axios.put(
        endpoint,
        {
          action: action,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      fetchRequestDetails();
      console.log("action request", response);
    } catch (err) {
      console.error("Failed to delete bond:", err);
      toast.error(err.message || "Failed to delete bond");
    }
  };

  const archiveBondId = async (id, isActive) => {
    const endpoint = `${base_url}/${api_type}/bonds/archive/${id}`;
    const payload = {
      isActive: isActive,
    };
    try {
      const response = await axios.put(endpoint, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      if (response.data.success) {
        toast.success("Bond status updated successfully");
        fetchBondDetails();
      }
    } catch (err) {
      console.error("Failed to update bond status:", err);
      toast.error(err.message || "Failed to update bond status");
    }
  };

  const getExportBondData = async () => {
    const endpoint = `${base_url}/${api_type}/bonds/exportToExcel`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      console.log("export bond get details", response);
      // setBondDetails(response?.data?.data?.bonds);

      // setPage(response?.data?.data?.pagination?.currentPage);

      // setTotal(response?.data?.data?.totalPages);
      // setPazeSize(response?.data?.data?.totalRecords);
    } catch (err) {
      console.error("Failed export bond get details:", err);
      // setError(err.message);
    }
  };

  useEffect(() => {
    fetchBondDetails();
  }, [searchInputApi, getData, page, selectNumber]);
  console.log("bond-details", bondDetails);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === "") {
      setSearchInputApi("");
    }
  }, [searchInput]);

  const handleSearchInput = (value) => {
    setSearchInput(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
    setPage(1);
    setPazeSize(value === "All" ? total : parseInt(value));
  };

  const columns = [
    columnHelper.accessor("bondId", {
      cell: (info) => info.renderValue(),
      header: () => <span>Bond Id</span>,
    }),

    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>Company Name</span>
        </div>
      ),
    }),

    columnHelper.accessor("issueType", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>Type</span>
        </div>
      ),
    }),

    columnHelper.accessor("maturity", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Maturity</span>
        </div>
      ),
    }),

    columnHelper.accessor("coupenRate", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Interest Rate</span>
        </div>
      ),
    }),

    columnHelper.accessor("createdAt", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Publish Date</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const isActive = info?.row?.original?.isActive;
        const isAchive = !isActive;
        console.log("investorid", uniqueId);
        const handleToggle = () => {
          // Find and update the bond's isActive status
          setBondDetails((prev) =>
            prev.map((bond) =>
              bond.id === uniqueId
                ? { ...bond, isActive: !bond.isActive }
                : bond
            )
          );
          archiveBondId(uniqueId, !isActive);

          // Optionally, make an API call to persist the change
          // Example:
          // toggleBondStatus(uniqueId, !isActive);
        };
        return (
          <div className="flex justify-start ">
            <div
              onClick={() => handleToggle()}
              className="relative inline-block w-10 align-middle select-none"
            >
              <input
                type="checkbox"
                name="toggle"
                value={!isActive}
                checked={!isActive}
                className={`${
                  !isActive ? "checked:bg-[#035C98]" : ""
                } outline-none focus:outline-none focus:ring-0 focus:border-none right-4 checked:right-0 duration-200 ease-in absolute block w-5 h-5 mt-[2px] border-none bg-[#B4BCC0] rounded-full appearance-none cursor-pointer`}
              />
              <label
                htmlFor={`${!isActive}-toggle`}
                className="block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
              ></label>
            </div>
          </div>
        );
      },
      header: () => <span>Archive</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          navigate("/bond/edit", {
            state: {
              uniqueId: uniqueId,
            },
          });
        };
        const deleteBond = (id) => {
          if (window.confirm("Are you sure you want to delete this bond?")) {
            // delete the item
            deleteBondsId(id);
          }
        };
        return (
          <div className="flex justify-start ">
            {userPermissionData?.bond?.edit && (
              <img
                onClick={() => NavigateScheme(uniqueId)}
                src={editBond}
                alt="Eye "
                className="cursor-pointer pr-8"
              />
            )}
            {userPermissionData?.bond?.delete && (
              <img
                onClick={() => deleteBond(uniqueId)}
                src={delBond}
                alt="Eye "
                className="cursor-pointer"
              />
            )}
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  // Handle the confirmation actions
  const handleConfirm = () => {
    toast.success("Action Confirmed!", {
      position: "top-center",
    });
    // Add any confirmation action logic here
  };

  const handleCancel = () => {
    toast.info("Action Canceled", {
      position: "top-center",
    });
    // Add any cancellation action logic here
  };

  const RequestListcolumns = [
    // columnHelper.accessor("bondId", {
    //   cell: (info) => info.renderValue(),
    //   header: () => <span>Bond Id</span>,
    // }),

    columnHelper.accessor("name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>Company Name</span>
        </div>
      ),
    }),

    columnHelper.accessor("isin", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className="">
          <span>ISIN</span>
        </div>
      ),
    }),

    columnHelper.accessor("createdAt", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Request Date</span>,
    }),
    columnHelper.accessor("requestor", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),

      header: () => <span>Requestors</span>,
    }),

    // columnHelper.accessor((row) => row, {
    //   id: "action",
    //   cell: (info) => {
    //     const uniqueId = info?.row?.original?.id;
    //     const isActive = info?.row?.original?.isActive;
    //     const isAchive = !isActive;
    //     console.log("investorid", uniqueId);
    //     const handleToggle = () => {
    //       // Find and update the bond's isActive status
    //       setBondDetails((prev) =>
    //         prev.map((bond) =>
    //           bond.id === uniqueId
    //             ? { ...bond, isActive: !bond.isActive }
    //             : bond
    //         )
    //       );
    //       archiveBondId(uniqueId, !isActive);

    //       // Optionally, make an API call to persist the change
    //       // Example:
    //       // toggleBondStatus(uniqueId, !isActive);
    //     };
    //     return (
    //       <div className="flex justify-start ">
    //         <div
    //           onClick={() => handleToggle()}
    //           className="relative inline-block w-10 align-middle select-none"
    //         >
    //           <input
    //             type="checkbox"
    //             name="toggle"
    //             value={!isActive}
    //             checked={!isActive}
    //             className={`${
    //               !isActive ? "checked:bg-[#035C98]" : ""
    //             } outline-none focus:outline-none focus:ring-0 focus:border-none right-4 checked:right-0 duration-200 ease-in absolute block w-5 h-5 mt-[2px] border-none bg-[#B4BCC0] rounded-full appearance-none cursor-pointer`}
    //           />
    //           <label
    //             htmlFor={`${!isActive}-toggle`}
    //             className="block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
    //           ></label>
    //         </div>
    //       </div>
    //     );
    //   },
    //   header: () => <span>Archive</span>,
    // }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const handleRequestFunction = (id, action) => {
          if (
            window.confirm(`Are you sure you want to ${action} this request?`)
          ) {
            handleRequest(id, action);
          }
        };
        return (
          <div className="flex justify-center w-full gap-10 ">
            {/* {userPermissionData?.bond?.edit && (
              <img
                onClick={() => NavigateScheme(uniqueId)}
                src={editBond}
                alt="Eye "
                className="cursor-pointer pr-8"
              />
            )} */}
            <div>
              <button
                onClick={() =>
                  handleRequestFunction(info?.row?.original?.id, "approve")
                }
                class="px-6 py-2 bg-[#289A3F] text-white rounded-lg shadow-md  transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#289A3F]"
              >
                Approve
              </button>
            </div>

            <div>
              <button
                onClick={() =>
                  handleRequestFunction(info?.row?.original?.id, "reject")
                }
                class="px-6 py-2 bg-[#DD0000] text-white rounded-lg shadow-md  transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#DD0000]"
              >
                Reject
              </button>
            </div>
            {/* {userPermissionData?.bond?.delete && (
              <img
                onClick={() => deleteBond(uniqueId)}
                src={delBond}
                alt="Eye "
                className="cursor-pointer"
              />
            )} */}
          </div>
        );
      },
      header: () => (
        <div className="w-full flex justify-center">
          <span className="">Action</span>
        </div>
      ),
    }),
  ];

  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  // const downloadData = () => {
  //   const customHeaders = [
  //     { label: "Start Date", key: "startDate" },
  //     { label: "End Date", key: "endDate" },
  //     { label: "Principal Amount", key: "principal" },
  //     { label: "Interest Earned", key: "interest" },
  //     { label: "Deduction (25%)", key: "deduction" },
  //     { label: "Net Interest", key: "netInterest" },
  //     { label: "Total Amount", key: "total" },
  //     { label: "Principal Per Month", key: "principalAmount" },
  //     { label: "Initial Investment", key: "investmentAmount" },
  //   ];

  //   // Create the CSV header row using custom labels
  //   const csvHeaders =
  //     customHeaders.map((header) => header.label).join(",") + "\n";

  //   // Create CSV rows using data and the key mappings
  //   const csvRows = data
  //     .map((row) =>
  //       customHeaders
  //         .map((header) => `"${row[header.key] || ""}"`) // Map each key to the value
  //         .join(",")
  //     )
  //     .join("\n");

  //   const csvContent = csvHeaders + csvRows;

  //   // Create a Blob and download it
  //   const blob = new Blob([csvContent], { type: "text/csv" });
  //   const url = URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = "data.csv";
  //   link.click();

  //   URL.revokeObjectURL(url); // Cleanup the URL object
  // };

  const handleExport = async () => {
    const endpoint = `${base_url}/${api_type}/bonds/exportToExcel`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
        responseType: "blob",
        params: {
          search: searchInputApi,
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      console.error(" exporting file:", response);
    } catch (error) {
      console.error("Error exporting file:", error);
      alert("Failed to export file.");
    }
  };

  const handleUpload = async (file) => {
    if (!file) return toast.error("Please select a file!");

    const formData = new FormData();
    formData.append("file", file);
    const endpoint = `${base_url}/${api_type}/bonds/importFromExcel`;

    try {
      toast.info("Uploading file, please wait...");
      const response = await axios.post(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          "Content-Type": "multipart/form-data",
        },
      });
      setGetData(!getData);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("Failed to upload file.");
    }
  };
  const buttonData = [
    {
      label: "Bond List",
      path: "/registration/investor", // Path for the Investor button
    },
    {
      label: "New Request",
      path: "/bond/n", // Path for the Wealth Partner button
    },
  ];

  const handleClick = (path, label) => {
    if (label === "New Request") {
      fetchRequestDetails();
    }
    setActiveTab(label);
    // navigate(path); // Navigate to the given path
  };

  return (
    <>
      <div className="mt-[100px] ml-5">
        {buttonData?.map((button, index) => (
          <button
            key={index}
            className={`w-[135px] text-[14px] px-4 py-2   ${
              activeTab === button.label ? "bg-[#035C98] text-white " : ""
            } ${
              index === 0 ? "rounded-l" : "rounded-r"
            } focus:outline-none focus:ring-2`}
            onClick={() => handleClick(button.path, button.label)} // Navigate on click
          >
            {button.label}
          </button>
        ))}
      </div>
      {activeTab === "Bond List" ? (
        <div className="flex flex-col min-h-[calc(100vh-60px)]">
          <div className="lg:ml-4 flex-1 flex flex-col">
            <div className=" mt-[5px] mb-4 flex items-center justify-end">
              {userPermissionData?.bond?.create && (
                <button
                  className="bg-[#035C98] text-white px-4 py-1 rounded-[10px] flex gap-2"
                  onClick={() => navigate("/bond/add")}
                >
                  <span>Add Bond</span>
                </button>
              )}
            </div>
            <div className="bg-white p-6 rounded-lg mb-4 overflow-auto">
              <h1 className="text-[#252C32] text-[24px] font-bold">
                Bond List{" "}
              </h1>

              <div className="border-b border-1 border-gray-300 pb-1"></div>
              <div class="">
                <div class="flex flex-wrap items-center justify-between gap-x-2 py-4 gap-y-4">
                  <div class="flex gap-0.5">
                    <input
                      type="text"
                      placeholder="Search by Unique ID/name"
                      className="rounded-l-[10px] w-[217px]"
                      value={searchInput}
                      onChange={(e) => handleSearchInput(e?.target?.value)}
                    />
                    <button
                      onClick={handleSearchClick}
                      className="bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[10px]"
                    >
                      Search
                    </button>
                  </div>
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleExport()}
                      className="bg-[#035C98] text-white px-4 py-2 rounded-[10px] flex "
                    >
                      Export
                    </button>
                    {userPermissionData?.bond?.create && (
                      <button
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        className="bg-[#035C98] text-white px-4 py-2 rounded-[10px] flex "
                      >
                        <span>Upload</span>
                      </button>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      accept=".xlsx, .xls"
                      style={{ display: "none" }} // Hide the input element
                      onChange={(e) => handleUpload(e.target.files[0])}
                    />

                    {/* <button
                className="bg-[#035C98] text-white px-4 py-2 rounded-[10px] flex ">
                  <span>Upload</span>
                </button> */}
                  </div>
                </div>
                <div className="flex items-center w-[154px] mt-4 gap-x-2">
                  <p className="text-gray-500 text-sm font-bold">Show</p>
                  <SelectButton
                    options={optionsShow}
                    selectedValue={selectNumber}
                    onSelect={handleSelectNumber}
                  />
                  <p className="text-gray-500 text-sm font-bold">Entries</p>
                </div>
              </div>
            </div>

            <div className="w-full font-poppins">
              <ReactTable
                key={JSON?.stringify(bondDetails)}
                defaultData={bondDetails}
                columns={columns}
              />
            </div>

            {bondDetails?.length > 0 && (
              <div className="w-auto mt-auto bg-white border-t">
                <CustomPagination
                  currentPage={page}
                  setCurrentPage={setPage}
                  totalItems={total}
                  itemsPerPage={pageSize}
                  maxPageNumbersToShow={5}
                  storageKey="bondManagementPage"
                />
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="flex flex-col min-h-[calc(100vh-60px)]">
          <div className="lg:ml-4 mt-10 flex-1 flex flex-col">
            <div className="bg-white p-6 rounded-lg mb-4 overflow-auto">
              <h1 className="text-[#252C32] text-[24px] font-bold">
                New Request{" "}
              </h1>

              <div className="border-b border-1 border-gray-300 pb-1"></div>
              <div class="">
                <div class="flex flex-wrap items-center justify-between gap-x-2 py-4 gap-y-4">
                  <div class="flex gap-0.5">
                    <input
                      type="text"
                      placeholder="Search by Unique ID/name"
                      className="rounded-l-[10px] w-[217px]"
                      value={searchInput}
                      onChange={(e) => handleSearchInput(e?.target?.value)}
                    />
                    <button
                      onClick={handleSearchClick}
                      className="bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[10px]"
                    >
                      Search
                    </button>
                  </div>
                  {/* <div className="flex gap-2">
                    <button
                      onClick={() => handleExport()}
                      className="bg-[#035C98] text-white px-4 py-2 rounded-[10px] flex "
                    >
                      Export
                    </button>
                    {userPermissionData?.bond?.create && (
                      <button
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        className="bg-[#035C98] text-white px-4 py-2 rounded-[10px] flex "
                      >
                        <span>Upload</span>
                      </button>
                    )}
                    <input
                      type="file"
                      id="fileInput"
                      accept=".xlsx, .xls"
                      style={{ display: "none" }} // Hide the input element
                      onChange={(e) => handleUpload(e.target.files[0])}
                    />

                  
                  </div> */}
                </div>
                <div className="flex items-center w-[154px] mt-4 gap-x-2">
                  <p className="text-gray-500 text-sm font-bold">Show</p>
                  <SelectButton
                    options={optionsShow}
                    selectedValue={selectNumber}
                    onSelect={handleSelectNumber}
                  />
                  <p className="text-gray-500 text-sm font-bold">Entries</p>
                </div>
              </div>
            </div>

            <div className="w-full font-poppins">
              <ReactTable
                key={JSON?.stringify(requestBonds)}
                defaultData={requestBonds}
                columns={RequestListcolumns}
              />
            </div>

            {requestBonds?.length > 0 && (
              <div className="w-auto mt-auto bg-white border-t">
                <CustomPagination
                  currentPage={page}
                  setCurrentPage={setPage}
                  totalItems={totalNewRequest}
                  itemsPerPage={pageSize}
                  maxPageNumbersToShow={5}
                  storageKey="bondNewManagementPage"
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BondManagementMainPage;
